import { render, staticRenderFns } from "./WhiteboardBoardsPanel.vue?vue&type=template&id=4d93fb1c&scoped=true&"
import script from "./WhiteboardBoardsPanel.vue?vue&type=script&lang=js&"
export * from "./WhiteboardBoardsPanel.vue?vue&type=script&lang=js&"
import style0 from "./WhiteboardBoardsPanel.vue?vue&type=style&index=0&id=4d93fb1c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d93fb1c",
  null
  
)

export default component.exports